import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import { isEmpty } from 'lodash'
import { ShiftServiceProxy, ShiftVO } from '@/service-proxies/app-v2/time.service-proxies'
import ModelTable from './components/ModelTable'
import ShiftTable from './components/ShiftTable'
import ShiftChart from './components/ShiftChart'
import ModelForm from './components/ModelForm'
import { format } from './utils'
import { actions, state } from './store'
import './index.less'
import { Loading, Visible } from './types'
import { Reactive } from '@/utils/decorators'

const ssp = new ShiftServiceProxy()

@Component
export default class ShiftModel extends Vue {
  @Ref() modelForm: ModelForm

  @Reactive(state) currentModelId: string = ''
  @Reactive(state) currentModelDetail: Partial<ShiftVO> = {}
  @Reactive(state) loading: Loading = {}
  @Reactive(state) visible: Visible = {}

  get canUpdateOrDelete() {
    return !!this.currentModelId
  }

  get isUsed() {
    return this.currentModelDetail?.isUsed === 1
  }

  @Watch('currentModelId')
  setCurrentModelDetail(val) {
    if (val) {
      actions.loadModelDetail()
    }
  }

  created() {
    actions.loadModelList()
  }

  async createModel() {
    await actions.createModel(this.modelForm.body)
    await actions.loadModelList()
  }

  async updateModel() {
    await actions.updateModel(this.modelForm.body, this.isUsed)
    await actions.loadModelList()
    await actions.loadModelDetail()
  }

  render() {
    const header = () => (
      <div style="display:flex">
        <a-button type="primary" style="margin-right: 8px" onClick={() => actions.setVisible({ createForm: true })}>
          {this.$t('create')}
        </a-button>
      </div>
    )

    const left = () => <ModelTable />

    const right = () =>
      !isEmpty(this.currentModelDetail) ? (
        <div style="height: 100%; display: flex; flex-direction: column">
          <div style="padding: 8px; background: #fff;">
            <a-spin spinning={this.loading.modelDetail}>
              <a-row>
                <a-col span={24}>
                  <general-title>{this.$t('page_console_shift_detail')}</general-title>
                </a-col>
                <a-col span={12} style="margin-bottom: 8px;">
                  <span style="font-weight: 700">{this.$t('page_shift_model_code')}</span>：
                  {this.currentModelDetail.code}
                </a-col>
                <a-col span={12} style="margin-bottom: 8px;">
                  <span style="font-weight: 700">{this.$t('page_shift_model_name')}</span>：
                  {this.currentModelDetail.name}
                </a-col>
                <a-col span={12}>
                  <span style="font-weight: 700">{this.$t('page_shift_model_day')}</span>：
                  {format(this.currentModelDetail.startTime)} - {format(this.currentModelDetail.endTime)}
                </a-col>
              </a-row>
            </a-spin>
          </div>
          <div style="height: 100%; padding: 8px; background: #fff; overflow-y: auto">
            <a-spin spinning={this.loading.modelDetail}>
              <general-title>{this.$t('page_console_shift_summary')}</general-title>
              <ShiftChart />
              <ShiftTable />
            </a-spin>
          </div>
        </div>
      ) : null

    const createModal = (
      <a-modal
        v-model={this.visible.createForm}
        title={this.$t('page_shift_model_model')}
        width={640}
        destroyOnClose
        confirmLoading={this.loading.createForm}
        maskClosable={false}
        onOk={this.createModel}
      >
        <ModelForm ref="modelForm" type="create" />
      </a-modal>
    )

    const updateModal = (
      <a-modal
        v-model={this.visible.updateForm}
        title={this.$t('page_shift_model_model')}
        width={640}
        destroyOnClose
        confirmLoading={this.loading.updateForm}
        maskClosable={false}
        onOk={this.updateModel}
      >
        <ModelForm ref="modelForm" type="update" currentModelDetail={this.currentModelDetail} />
      </a-modal>
    )

    const _default = () => [createModal, updateModal]

    return (
      <general-layout
        clean
        bodyStyle={{ height: 'calc(100% - 48px)' }}
        scopedSlots={{ header, left, right, default: _default }}
      />
    )
  }
}
